window.$ = window.jQuery = require('jquery');

require('bootstrap');
require('./jquery.multi-select.js');
require('./jquery.multiselect.js');
require('flatpickr');
